import React, { useEffect, useState } from "react";
import Select from "react-select";
import { handleGetAvailabilityTimeSlot } from "../../../services/shef";
import { handleGetCitites } from "../../../services/region";

const NewScreen02 = ({
  is_monday,
  is_tuesday,
  is_wednesday,
  is_thursday,
  is_friday,
  is_saturday,
  is_sunday,
  availability_time_slots,
  cities,
  // expiry_days, // COMMENTED OUT: shelf life removed from UI
  updateFields,
}) => {
  const [timeSlot, setTimeSlot] = useState([]);
  const [selectedAvailabilitySlot, setSelectedAvailabilitySlot] = useState([]);
  const [citiesOption, setCitiesOption] = useState([]);
  const [selectedCities, setSelectedCities] = useState([]);

  // --- Logic Helpers ---
  function convertTo12Hour(time24) {
    let [hours, minutes] = time24.split(":");
    hours = parseInt(hours);
    if (hours === 24) hours = 0;
    const suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${hours}:${minutes} ${suffix}`;
  }

  useEffect(() => {
    const fetchAvailabilitySlot = async () => {
      try {
        const response = await handleGetAvailabilityTimeSlot();
        const reArrangeTimeSlot = response?.map((period) => ({
          id: period.id,
          value: `${convertTo12Hour(period.time_start)} - ${convertTo12Hour(period.time_end)}`,
          label: `${convertTo12Hour(period.time_start)} - ${convertTo12Hour(period.time_end)}`,
        }));
        setTimeSlot(reArrangeTimeSlot);
      } catch (error) {
        console.error("Error fetching slots", error);
      }
    };
    fetchAvailabilitySlot();
  }, []);

  const handleAvailabilitySlotChnage = (selectedValue) => {
    const availability = selectedValue?.map((slot) => slot.id) || [];
    setSelectedAvailabilitySlot(selectedValue);
    updateFields({ availability_time_slots: availability });
  };

  useEffect(() => {
    if (availability_time_slots?.length > 0 && timeSlot.length > 0) {
      const matched = timeSlot.filter((item) =>
        availability_time_slots.some((id) => (id.availability_time_slots_id === item.id || id === item.id))
      );
      setSelectedAvailabilitySlot(matched);
    }
  }, [timeSlot, availability_time_slots]);

  // Fetch cities
  // NewScreen02.js - Update the cities handling logic

// In the useEffect that fetches cities, modify it to set Karachi as default
useEffect(() => {
  const fetchCities = async () => {
    try {
      const cityRes = await handleGetCitites();
      const formatedCities = cityRes.map((obj) => ({ 
        id: obj.id, 
        value: obj.name, 
        label: obj.name, 
        country_id: obj.country_id 
      }));
      
      setCitiesOption(formatedCities);
      
      // Find Karachi in the list
      const karachiCity = formatedCities.find(city => 
        city.label.toLowerCase().includes("karachi")
      );
      
      // If cities prop is empty and we found Karachi, set it as default
      if ((!cities || cities.length === 0) && karachiCity) {
        setSelectedCities([karachiCity]);
        updateFields({ cities: [karachiCity.id] });
      }
    } catch (error) {
      console.error("Error fetching cities", error);
    }
  };
  fetchCities();
}, []);


  const handleCitiesChange = (selectedValue) => {
    setSelectedCities(selectedValue);
    const selectedCitiesID = selectedValue.map((item) => item.id);
    updateFields({ cities: selectedCitiesID });
  };

  useEffect(() => {
  if (cities?.length > 0 && citiesOption.length > 0) {
    const matched = citiesOption.filter((item) => 
      cities.some((id) => id === item.id)
    );
    setSelectedCities(matched);
  }
}, [citiesOption, cities]);

  // COMMENTED OUT: Shelf life handlers removed since it's hardcoded to 1 day
  // const handleIncrement = () => updateFields({ expiry_days: (expiry_days || 0) + 1 });
  // const handleDecrement = () => updateFields({ expiry_days: expiry_days > 0 ? expiry_days - 1 : 0 });

  // const handleInputChange = (e) => {
  //   const value = parseInt(e.target.value, 10);
  //   updateFields({ expiry_days: isNaN(value) ? 0 : value });
  // };

  // Hardcode expiry_days to 1 when component mounts
  useEffect(() => {
    // Set default shelf life to 1 day
    updateFields({ expiry_days: 1 });
  }, []);

  // --- UI Components ---
  const SectionLabel = ({ title, subtitle }) => (
    <div className="mb-3">
      <h3 className="text-lg font-bold text-gray-800">{title}</h3>
      {subtitle && <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>}
    </div>
  );

  return (
    <div className="max-w-5xl mx-auto py-6 px-4 space-y-6">
      {/* 1. MASTER INSTRUCTIONS */}
      <div className="bg-gradient-to-r from-primaryDark to-primary text-white p-6 rounded-xl shadow-lg">
        <h1 className="text-2xl font-extrabold mb-2 text-white">Delivery & Logistics</h1>
        <p className="opacity-90 text-sm mb-4">Set up when and where customers can order your dish.</p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs font-medium">
          <div className="flex items-center gap-2 bg-white/10 p-3 rounded-lg border border-white/20">
            <span className="bg-white text-secondary rounded-full w-6 h-6 flex items-center justify-center font-bold text-xs">1</span>
            Select delivery days
          </div>
          <div className="flex items-center gap-2 bg-white/10 p-3 rounded-lg border border-white/20">
            <span className="bg-white text-secondary rounded-full w-6 h-6 flex items-center justify-center font-bold text-xs">2</span>
            Choose time slots
          </div>
          <div className="flex items-center gap-2 bg-white/10 p-3 rounded-lg border border-white/20">
            <span className="bg-white text-secondary rounded-full w-6 h-6 flex items-center justify-center font-bold text-xs">3</span>
            Set delivery areas
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* LEFT COLUMN */}
        <div className="space-y-6">
          {/* 2. DELIVERY DAYS */}
          <section className="bg-white p-5 rounded-xl border shadow-sm">
            <SectionLabel 
              title="Delivery Days" 
              subtitle="Select the days this dish will be available for delivery." 
            />
            <div className="grid grid-cols-4 md:grid-cols-7 gap-2">
              {[
                { key: "is_monday", label: "Mon", state: is_monday },
                { key: "is_tuesday", label: "Tue", state: is_tuesday },
                { key: "is_wednesday", label: "Wed", state: is_wednesday },
                { key: "is_thursday", label: "Thu", state: is_thursday },
                { key: "is_friday", label: "Fri", state: is_friday },
                { key: "is_saturday", label: "Sat", state: is_saturday },
                { key: "is_sunday", label: "Sun", state: is_sunday },
              ].map((day) => (
                <button
                  key={day.key}
                  onClick={() => updateFields({ [day.key]: day.state === 1 ? 0 : 1 })}
                  className={`py-3 rounded-lg font-bold transition-all border-2 text-sm ${
                    day.state === 1 
                    ? "bg-primary border-primary text-white shadow-md scale-105" 
                    : "bg-white border-gray-100 text-gray-400 hover:border-gray-200"
                  }`}
                >
                  {day.label}
                </button>
              ))}
            </div>
          </section>

          {/* 3. TIME SLOTS */}
          <section className="bg-white p-5 rounded-xl border shadow-sm">
            <SectionLabel 
              title="Delivery Time Slots" 
              subtitle="Choose when customers can schedule deliveries." 
            />
            <Select
              isMulti
              options={timeSlot}
              value={selectedAvailabilitySlot}
              onChange={handleAvailabilitySlotChnage}
              placeholder="Select time windows..."
              className="text-sm"
            />
          </section>

          {/* 5. REMOVED: Shelf Life section - Hardcoded to 1 day */}
          {/* COMMENTED OUT: Shelf Life UI
          <section className="bg-white p-6 rounded-xl border shadow-sm">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <SectionLabel 
                title="Shelf Life" 
                subtitle="How many days does the dish stay fresh after delivery?" 
              />
              <div className="flex items-center justify-between bg-gray-100 p-2 rounded-2xl w-full md:w-64">
                <button onClick={handleDecrement} className="w-12 h-12 flex items-center justify-center bg-white rounded-xl shadow-sm hover:text-red-500 transition-colors">
                  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M5 11h14v2H5z"/>
                  </svg>
                </button>
                <div className="flex items-baseline gap-1">
                  <input 
                    className="bg-transparent text-center text-2xl font-black w-12 outline-none"
                    type="text"
                    value={expiry_days}
                    onChange={handleInputChange}
                  />
                  <span className="text-gray-500 font-bold text-sm uppercase">Days</span>
                </div>
                <button onClick={handleIncrement} className="w-12 h-12 flex items-center justify-center bg-white rounded-xl shadow-sm hover:text-green-500 transition-colors">
                  <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2h6z"/>
                  </svg>
                </button>
              </div>
            </div>
          </section>
          */}
        </div>

        {/* RIGHT COLUMN */}
        <div className="space-y-6">
          {/* 4. DELIVERY CITIES */}
          <section className="bg-white p-5 rounded-xl border shadow-sm">
            <SectionLabel 
              title="Delivery Cities" 
              subtitle="Where can customers order this dish from?" 
            />
            <Select
              isMulti
              options={citiesOption}
              value={selectedCities}
              onChange={handleCitiesChange}
              placeholder="Search and add cities..."
              className="text-gray-700 text-sm mb-3"
            />
            <div className="flex flex-wrap gap-2">
              {selectedCities.map((option) => (
                <span key={option.value} className="bg-slate-100 text-slate-700 px-3 py-1 rounded-full text-xs font-bold border border-slate-200 uppercase tracking-tighter">
                  {option.label}
                </span>
              ))}
            </div>
          </section>

          {/* 7. FINAL CHECKLIST - Updated to remove shelf life check */}
          <div className="bg-emerald-50 p-5 rounded-xl border-2 border-emerald-200">
            <h3 className="text-lg font-bold text-emerald-900 mb-3 flex items-center gap-2">
              <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path d="M5 13l4 4L19 7"></path>
              </svg>
              Completion Checklist
            </h3>
            <div className="space-y-3">
              {[
                { label: "At least one delivery day selected", done: (is_monday || is_tuesday || is_wednesday || is_thursday || is_friday || is_saturday || is_sunday) },
                { label: "Time slots assigned", done: selectedAvailabilitySlot.length > 0 },
                { label: "Delivery cities selected", done: selectedCities.length > 0 },
                // COMMENTED OUT: Shelf life check - hardcoded to 1 day
                // { label: "Shelf life defined", done: expiry_days > 0 },
              ].map((item, i) => (
                <div key={i} className={`flex items-center gap-2.5 p-2.5 rounded-lg bg-white shadow-sm border ${item.done ? "border-emerald-200" : "border-gray-200 opacity-60"}`}>
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${item.done ? "bg-emerald-500 border-emerald-500 text-white" : "border-gray-300 text-transparent"}`}>
                    {item.done && <svg width="10" height="10" fill="none" stroke="currentColor" strokeWidth="4" viewBox="0 0 24 24"><path d="M5 13l4 4L19 7"></path></svg>}
                  </div>
                  <span className={`text-xs ${item.done ? "text-emerald-800 font-medium" : "text-gray-400 italic"}`}>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewScreen02; 